import axios from 'axios';
import localforage from "localforage";
import * as urls from '../config/config'

export const saveNewWorkday = function(workday, store) {
    localforage.getItem('token')
        .then(function(value) {
            return axios.post(urls.api.current + '/import/batch', {workdays: [workday]}, { headers: {'Authorization': 'Bearer ' + value } });
        })
        .then(function({data}) {
            if (process.env.NODE_ENV === 'development') console.log('saved new workday', data.data.workdays[0]);

            let newWorkday = data.data.workdays[0];
            newWorkday.synced = true;

            return window.workdayStore.setItem(newWorkday.id.toString(), newWorkday);
        })
        .then(function(value) {
            if (process.env.NODE_ENV === 'development') console.log('stored new workday local', value);

            if (workday.id !== value.id) window.workdayStore.removeItem(workday.id.toString());

            const day = store.getters.workdayById(workday.id);

            day.id = value.id;
            day.synced = true;
        });
};

export const updateWorkday = function(workday) {
    localforage.getItem('token')
        .then(function(value) {
            if (Object.prototype.hasOwnProperty.call(workday, 'synced') && !workday.synced) {
                const config = {
                    headers: {
                        'Authorization': 'Bearer ' + value
                    }
                }
                return axios.put(urls.api.current + '/workdays/' + workday.id, workday, config)
            }
        })
        .then(function ({data}) {
            let updatedWorkday = data
            updatedWorkday.synced = true

            return window.workdayStore.setItem(updatedWorkday.id.toString(), updatedWorkday)
        })
}
